import { render, staticRenderFns } from "./FilterMessage.vue?vue&type=template&id=41238254&"
import script from "./FilterMessage.vue?vue&type=script&lang=js&"
export * from "./FilterMessage.vue?vue&type=script&lang=js&"
import style0 from "./FilterMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports